module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-venue-cc4a63f741c40d83d474ddf7d3b241b4.png";